export interface SiteLanguage {
  code: string
  label: string
  nativeName: string
  countries: string
  aliases: string
}

// Google Cloud Translation Basic NMT codes. Countries are discovery aids, not
// an exhaustive list of speakers or a claim of official-language status.
const entries: [string, string, string, string, string?][] = [
  ['af', 'Afrikaans', 'Afrikaans', 'South Africa, Namibia'],
  ['sq', 'Albanian', 'Shqip', 'Albania, Kosovo, North Macedonia'],
  ['am', 'Amharic', 'አማርኛ', 'Ethiopia'],
  ['ar', 'Arabic', 'العربية', 'Algeria, Bahrain, Chad, Comoros, Djibouti, Egypt, Iraq, Jordan, Kuwait, Lebanon, Libya, Mauritania, Morocco, Oman, Palestine, Qatar, Saudi Arabia, Somalia, Sudan, Syria, Tunisia, United Arab Emirates, Yemen', 'UAE'],
  ['hy', 'Armenian', 'Հայերեն', 'Armenia'],
  ['as', 'Assamese', 'অসমীয়া', 'India'],
  ['ay', 'Aymara', 'Aymar aru', 'Bolivia, Peru, Chile'],
  ['az', 'Azerbaijani', 'Azərbaycanca', 'Azerbaijan, Iran'],
  ['bm', 'Bambara', 'Bamanankan', 'Mali'],
  ['eu', 'Basque', 'Euskara', 'Spain, France'],
  ['be', 'Belarusian', 'Беларуская', 'Belarus'],
  ['bn', 'Bengali', 'বাংলা', 'Bangladesh, India', 'Bangla'],
  ['bho', 'Bhojpuri', 'भोजपुरी', 'India, Nepal, Mauritius'],
  ['bs', 'Bosnian', 'Bosanski', 'Bosnia and Herzegovina'],
  ['bg', 'Bulgarian', 'Български', 'Bulgaria'],
  ['my', 'Burmese', 'မြန်မာ', 'Myanmar', 'Burma'],
  ['yue', 'Cantonese', '粵語 廣東話', 'China, Hong Kong, Macao', 'Yue Macau'],
  ['ca', 'Catalan', 'Català', 'Andorra, Spain, France, Italy'],
  ['ceb', 'Cebuano', 'Cebuano Bisaya', 'Philippines'],
  ['ny', 'Chichewa', 'Chichewa', 'Malawi, Zambia, Mozambique', 'Nyanja'],
  ['zh-CN', 'Chinese (Simplified)', '中文 简体中文', 'China, Singapore, Malaysia', 'Mandarin'],
  ['zh-TW', 'Chinese (Traditional)', '中文 繁體中文', 'Taiwan, Hong Kong, Macao', 'Mandarin Macau'],
  ['co', 'Corsican', 'Corsu', 'France, Italy'],
  ['hr', 'Croatian', 'Hrvatski', 'Croatia, Bosnia and Herzegovina'],
  ['cs', 'Czech', 'Čeština', 'Czechia', 'Czech Republic'],
  ['da', 'Danish', 'Dansk', 'Denmark, Greenland, Faroe Islands'],
  ['dv', 'Divehi', 'ދިވެހި', 'Maldives', 'Dhivehi Maldivian'],
  ['doi', 'Dogri', 'डोगरी', 'India'],
  ['nl', 'Dutch', 'Nederlands', 'Netherlands, Belgium, Suriname, Aruba, Curaçao, Sint Maarten', 'Holland'],
  ['en', 'English', 'English', 'United States, United Kingdom, Australia, Canada, New Zealand, Ireland, India, Singapore, Philippines, South Africa, Nigeria, Ghana, Kenya, Uganda, Tanzania, Zambia, Zimbabwe, Botswana, Namibia, Malawi, Lesotho, Eswatini, Liberia, Sierra Leone, Gambia, Cameroon, Rwanda, South Sudan, Sudan, Mauritius, Seychelles, Malta, Pakistan, Belize, Guyana, Jamaica, Trinidad and Tobago, Bahamas, Barbados, Antigua and Barbuda, Dominica, Grenada, Saint Kitts and Nevis, Saint Lucia, Saint Vincent and the Grenadines, Fiji, Papua New Guinea, Solomon Islands, Vanuatu, Samoa, Tonga, Tuvalu, Kiribati, Nauru, Palau, Marshall Islands, Micronesia', 'USA US UK Britain Great Britain United States of America'],
  ['eo', 'Esperanto', 'Esperanto', 'International'],
  ['et', 'Estonian', 'Eesti', 'Estonia'],
  ['ee', 'Ewe', 'Eʋegbe', 'Ghana, Togo'],
  ['tl', 'Filipino (Tagalog)', 'Filipino Tagalog', 'Philippines', 'fil'],
  ['fi', 'Finnish', 'Suomi', 'Finland'],
  ['fr', 'French', 'Français', 'France, Belgium, Canada, Switzerland, Luxembourg, Monaco, Haiti, Benin, Burkina Faso, Burundi, Cameroon, Central African Republic, Chad, Comoros, Republic of the Congo, Democratic Republic of the Congo, Djibouti, Equatorial Guinea, Gabon, Guinea, Ivory Coast, Madagascar, Mali, Niger, Rwanda, Senegal, Seychelles, Togo, Vanuatu', 'Cote d Ivoire DRC DR Congo'],
  ['fy', 'Frisian', 'Frysk', 'Netherlands', 'Western Frisian'],
  ['gl', 'Galician', 'Galego', 'Spain'],
  ['ka', 'Georgian', 'ქართული', 'Georgia'],
  ['de', 'German', 'Deutsch', 'Germany, Austria, Switzerland, Liechtenstein, Luxembourg, Belgium'],
  ['el', 'Greek', 'Ελληνικά', 'Greece, Cyprus'],
  ['gn', 'Guarani', 'Avañeʼẽ', 'Paraguay, Bolivia, Argentina, Brazil'],
  ['gu', 'Gujarati', 'ગુજરાતી', 'India'],
  ['ht', 'Haitian Creole', 'Kreyòl ayisyen', 'Haiti'],
  ['ha', 'Hausa', 'Hausa هَوُسَ', 'Nigeria, Niger'],
  ['haw', 'Hawaiian', 'ʻŌlelo Hawaiʻi', 'United States', 'Hawaii USA'],
  ['he', 'Hebrew', 'עברית', 'Israel', 'iw'],
  ['hi', 'Hindi', 'हिन्दी', 'India', 'हिंदी'],
  ['hmn', 'Hmong', 'Hmoob', 'China, Vietnam, Laos, Thailand'],
  ['hu', 'Hungarian', 'Magyar', 'Hungary'],
  ['is', 'Icelandic', 'Íslenska', 'Iceland'],
  ['ig', 'Igbo', 'Igbo', 'Nigeria'],
  ['ilo', 'Ilocano', 'Ilokano', 'Philippines'],
  ['id', 'Indonesian', 'Bahasa Indonesia', 'Indonesia'],
  ['ga', 'Irish', 'Gaeilge', 'Ireland', 'Irish Gaelic'],
  ['it', 'Italian', 'Italiano', 'Italy, San Marino, Switzerland, Vatican City'],
  ['ja', 'Japanese', '日本語', 'Japan'],
  ['jv', 'Javanese', 'Basa Jawa', 'Indonesia', 'jw'],
  ['kn', 'Kannada', 'ಕನ್ನಡ', 'India'],
  ['kk', 'Kazakh', 'Қазақ тілі', 'Kazakhstan'],
  ['km', 'Khmer', 'ភាសាខ្មែរ', 'Cambodia'],
  ['rw', 'Kinyarwanda', 'Ikinyarwanda', 'Rwanda'],
  ['gom', 'Konkani', 'कोंकणी', 'India'],
  ['ko', 'Korean (Original)', '한국어', 'South Korea, North Korea', '대한민국 조선말 Republic of Korea'],
  ['kri', 'Krio', 'Krio', 'Sierra Leone'],
  ['ku', 'Kurdish (Kurmanji)', 'Kurdî Kurmancî', 'Türkiye, Syria, Iraq, Iran', 'Turkey'],
  ['ckb', 'Kurdish (Sorani)', 'کوردی سۆرانی', 'Iraq, Iran'],
  ['ky', 'Kyrgyz', 'Кыргызча', 'Kyrgyzstan'],
  ['lo', 'Lao', 'ລາວ', 'Laos'],
  ['la', 'Latin', 'Latina', 'Vatican City'],
  ['lv', 'Latvian', 'Latviešu', 'Latvia'],
  ['ln', 'Lingala', 'Lingála', 'Democratic Republic of the Congo, Republic of the Congo, Angola, Central African Republic', 'DRC DR Congo'],
  ['lt', 'Lithuanian', 'Lietuvių', 'Lithuania'],
  ['lg', 'Luganda', 'Luganda', 'Uganda', 'Ganda'],
  ['lb', 'Luxembourgish', 'Lëtzebuergesch', 'Luxembourg'],
  ['mk', 'Macedonian', 'Македонски', 'North Macedonia'],
  ['mai', 'Maithili', 'मैथिली', 'India, Nepal'],
  ['mg', 'Malagasy', 'Malagasy', 'Madagascar'],
  ['ms', 'Malay', 'Bahasa Melayu', 'Malaysia, Brunei, Singapore'],
  ['ml', 'Malayalam', 'മലയാളം', 'India'],
  ['mt', 'Maltese', 'Malti', 'Malta'],
  ['mi', 'Maori', 'Te reo Māori', 'New Zealand'],
  ['mr', 'Marathi', 'मराठी', 'India'],
  ['mni-Mtei', 'Meiteilon (Manipuri)', 'ꯃꯤꯇꯩꯂꯣꯟ মৈতৈলোন', 'India'],
  ['lus', 'Mizo', 'Mizo ṭawng', 'India, Myanmar, Bangladesh'],
  ['mn', 'Mongolian', 'Монгол', 'Mongolia, China'],
  ['ne', 'Nepali', 'नेपाली', 'Nepal, India, Bhutan'],
  ['no', 'Norwegian', 'Norsk', 'Norway', 'Bokmal Bokmål Nynorsk'],
  ['or', 'Odia (Oriya)', 'ଓଡ଼ିଆ', 'India'],
  ['om', 'Oromo', 'Afaan Oromoo', 'Ethiopia, Kenya'],
  ['ps', 'Pashto', 'پښتو', 'Afghanistan, Pakistan'],
  ['fa', 'Persian', 'فارسی', 'Iran, Afghanistan', 'Farsi Dari'],
  ['pl', 'Polish', 'Polski', 'Poland'],
  ['pt', 'Portuguese', 'Português', 'Portugal, Brazil, Angola, Mozambique, Cape Verde, Guinea-Bissau, São Tomé and Príncipe, Timor-Leste, Equatorial Guinea, Macao', 'Cabo Verde East Timor Macau'],
  ['pa', 'Punjabi', 'ਪੰਜਾਬੀ', 'India, Pakistan', 'Panjabi'],
  ['qu', 'Quechua', 'Runasimi', 'Peru, Bolivia, Ecuador'],
  ['ro', 'Romanian', 'Română', 'Romania, Moldova'],
  ['ru', 'Russian', 'Русский', 'Russia, Belarus, Kazakhstan, Kyrgyzstan'],
  ['sm', 'Samoan', 'Gagana Samoa', 'Samoa, American Samoa'],
  ['sa', 'Sanskrit', 'संस्कृतम्', 'India'],
  ['gd', 'Scots Gaelic', 'Gàidhlig', 'United Kingdom', 'Scotland UK Britain'],
  ['nso', 'Sepedi', 'Sepedi Sesotho sa Leboa', 'South Africa', 'Northern Sotho'],
  ['sr', 'Serbian', 'Српски Srpski', 'Serbia, Bosnia and Herzegovina, Montenegro, Kosovo'],
  ['st', 'Sesotho', 'Sesotho', 'Lesotho, South Africa', 'Southern Sotho'],
  ['sn', 'Shona', 'ChiShona', 'Zimbabwe, Mozambique'],
  ['sd', 'Sindhi', 'سنڌي', 'Pakistan, India'],
  ['si', 'Sinhala', 'සිංහල', 'Sri Lanka', 'Sinhalese'],
  ['sk', 'Slovak', 'Slovenčina', 'Slovakia'],
  ['sl', 'Slovenian', 'Slovenščina', 'Slovenia'],
  ['so', 'Somali', 'Soomaali', 'Somalia, Djibouti, Ethiopia, Kenya'],
  ['es', 'Spanish', 'Español', 'Spain, Mexico, Argentina, Bolivia, Chile, Colombia, Costa Rica, Cuba, Dominican Republic, Ecuador, El Salvador, Equatorial Guinea, Guatemala, Honduras, Nicaragua, Panama, Paraguay, Peru, Puerto Rico, Uruguay, Venezuela, United States', 'Castellano USA'],
  ['su', 'Sundanese', 'Basa Sunda', 'Indonesia'],
  ['sw', 'Swahili', 'Kiswahili', 'Tanzania, Kenya, Uganda, Democratic Republic of the Congo, Rwanda, Burundi, Comoros', 'DRC DR Congo'],
  ['sv', 'Swedish', 'Svenska', 'Sweden, Finland'],
  ['tg', 'Tajik', 'Тоҷикӣ', 'Tajikistan'],
  ['ta', 'Tamil', 'தமிழ்', 'India, Sri Lanka, Singapore, Malaysia'],
  ['tt', 'Tatar', 'Татарча', 'Russia'],
  ['te', 'Telugu', 'తెలుగు', 'India'],
  ['th', 'Thai', 'ไทย', 'Thailand'],
  ['ti', 'Tigrinya', 'ትግርኛ', 'Eritrea, Ethiopia'],
  ['ts', 'Tsonga', 'itsonga', 'South Africa, Mozambique, Eswatini, Zimbabwe'],
  ['tn', 'Tswana', 'Setswana', 'Botswana, South Africa, Namibia, Zimbabwe'],
  ['tr', 'Turkish', 'Türkçe', 'Türkiye, Cyprus', 'Turkey'],
  ['tk', 'Turkmen', 'Türkmençe', 'Turkmenistan'],
  ['ak', 'Twi (Akan)', 'Twi Akan', 'Ghana'],
  ['uk', 'Ukrainian', 'Українська', 'Ukraine'],
  ['ur', 'Urdu', 'اردو', 'Pakistan, India'],
  ['ug', 'Uyghur', 'ئۇيغۇرچە', 'China', 'Uighur'],
  ['uz', 'Uzbek', 'Oʻzbekcha', 'Uzbekistan'],
  ['vi', 'Vietnamese', 'Tiếng Việt', 'Vietnam', 'Viet Nam'],
  ['cy', 'Welsh', 'Cymraeg', 'United Kingdom', 'Wales UK Britain'],
  ['xh', 'Xhosa', 'isiXhosa', 'South Africa, Zimbabwe'],
  ['yi', 'Yiddish', 'ייִדיש', 'Israel, United States', 'USA'],
  ['yo', 'Yoruba', 'Yorùbá', 'Nigeria, Benin, Togo'],
  ['zu', 'Zulu', 'isiZulu', 'South Africa'],
]

export const SITE_LANGUAGES: SiteLanguage[] = entries
  .map(([code, label, nativeName, countries, aliases = '']) => ({ code, label, nativeName, countries, aliases }))
  .sort((a, b) => a.label.localeCompare(b.label, 'en'))

function normalizeSearch(value: string): string {
  return value.normalize('NFKD').replace(/\p{M}/gu, '').toLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim()
}

const searchIndex = SITE_LANGUAGES.map(language => ({
  language,
  words: normalizeSearch([language.label, language.nativeName, language.countries, language.code, language.aliases].join(' ')).split(' '),
}))

export function searchSiteLanguages(query: string): SiteLanguage[] {
  const tokens = normalizeSearch(query).split(/\s+/).filter(Boolean)
  return searchIndex
    .filter(({ words }) => tokens.every(token => words.some(word => word.startsWith(token))))
    .map(({ language }) => language)
}
